import { useCallback } from 'react';
import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';

export const LazyContributeSection: React.FC = () => {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/homepage_contribute_section" */ '../ContributeSection'))
				.ContributeSection,
		[],
	);

	return (
		<ClientRender placeholder={<Spinner className="mx-auto my-64" />}>
			<ScrollableComponent topOffset={200} immediateForBots>
				<LazyComponent loadComponent={loadComponent} />
			</ScrollableComponent>
		</ClientRender>
	);
};
